// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';

import '../styles/editable.css';

export default class Editable extends React.Component {

    state = {
        edit: false,
        value: ""
    }

    saveChanges = async () => {
        const value = this.state.value;
        await this.setState({ value: "", edit: false });
        this.props.setValue(value);
    }
    
    componentDidUpdate(oldProps) {
        // If our provided value prop changes, update our value and stop editing
        if (oldProps.value !== this.props.value) {
            this.setState({
                edit: false,
                value: this.props.value,
            });
        }
    }

    render = () => {
        return (<div
            className={this.props.className ? this.props.className : ""}
            style={this.props.style ? this.props.style : {}}
        >

            {this.state.edit ? 
            
            // Edit mode
            <div className="editable-input">
                <input
                    ref="textbox"
                    id="editable"
                    name="editable"
                    className={this.props.inputClass}
                    placeholder={this.props.placeholder ? this.props.placeholder : "Enter value..."}
                    type="text"
                    value={this.state.value}
                    onChange={(e) => this.setState({ value: e.target.value })}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") this.saveChanges();
                    }}
                />
                <img 
                    alt="Save"
                    src="https://static.stax.ai/images/icons/confirm.png"
                    title="Click or hit Enter to save"
                    className="editable-button"
                    onClick={this.saveChanges}
                />
            </div> : 

            // View mode
            <div className={"editable-value" + (this.props.containerClass ? " " + this.props.containerClass : "")} title={this.props.value}>
                {this.props.value && this.props.value !== "" ? <div className={this.props.valueClass}>
                    {this.props.value + (this.props.suffix ? this.props.suffix : "")}
                </div> : this.props.placeholder ? <div
                    className={this.props.placeholderClass ? this.props.placeholderClass : this.props.valueClass}
                    style={this.props.placeholderClass ? {} : { color: "rgb(180,180,180)" }}
                >
                    {this.props.placeholder}
                </div> : ""}
                {this.props.editable !== false && <img
                    alt="Edit"
                    src="https://static.stax.ai/images/icons/edit.png"
                    className="editable-button"
                    title={"Click to edit " + (this.props.fieldName ? this.props.fieldName : "field")}
                    onClick={() => {
                        this.setState({ value: this.props.value, edit: this.props.editable !== false });
                        setTimeout(() => {
                            const input = this.refs.textbox;
                            input.focus();
                            input.select();
                        }, 150);
                    }}
                />}
            </div>}

        </div>)
    }

};